import * as actionTypes from "./actionTypes";
import * as actions from "./index";
import { saveUploadInfo } from "Flow2/components/CustomCollections/CustomDataLog/CustomDataLog";
import { isNLW } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController.js';
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";

export const setAddFormState = (formState) => {
    return {
        type: actionTypes.CUSTOM_SET_ADDFORM_STATE,
        payload: formState
    }
}

export const setNewData = (newData) => {
    return {
        type: actionTypes.CUSTOM_SET_NEWDATA,
        payload: newData
    }
}

export const sendEmailStart = (emailObj) => {
    return {
        type: actionTypes.CUSTOM_SEND_EMAIL_START,
        payload: emailObj
    }
}

export const sendEmailSuccess = (res) => {
    return {
        type: actionTypes.CUSTOM_SEND_EMAIL_SUCCESS,
        payload: res
    }
}

export const getFtvmetaUlConstraintsSuccess = (res) => {
    return {
        type: actionTypes.CUSTOM_GET_UL_CONSTRAINTS_SUCCESS,
        payload: res
    }
}

export const sendEmail = (emailObj) => {
    //console.log("LAMTEST emailObj", emailObj);
    let isUploading = false;
    if (emailObj && ((emailObj.text && emailObj.text !== "") || (emailObj.htm && emailObj.html !== ""))) {
        return (dispatch, getState) => {
            dispatch(sendEmailStart(emailObj));
            if (getState().customData.customUploadInfo && getState().customData.customUploadInfo.isLoading) isUploading = true;
            if (isUploading) saveUploadInfo(dispatch, emailObj, "", 'SendEmail');
            window.flow.mail(emailObj).then(res => {
                // console.log("LAMTEST emailObj res", res);
                if (isUploading) saveUploadInfo(dispatch, res, "", 'SendEmailStatus');
                dispatch(sendEmailSuccess(res));
                dispatch(actions.addMessage('popup.title.email.send.success', null, 'text', 'dialog'));
            });

        }
    }
    return;
}

export const saveLastCustomData4UserSuccess = (res) => {
    return {
        type: actionTypes.CUSTOM_SAVE_LASTCUSTOMDATA_SUCCESS,
        payload: res
    }
}

export const setCustomFullTextSearchData = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_FULLTEXT_SEARCH_DATA,
        payload: data
    }
}

export const setCustomLastByFieldsData = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_BYFIEDS_SEARCH_DATA,
        payload: data
    }
}

export const setCustomLastSearchType = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_LAST_SEARCH_TYPE,
        payload: data
    }
}

export function saveLastCustomData4User(userdata, option, lastCustomData) {
    let userid = userdata.id;
    let groupid = userdata.groupid;
    return dispatch => {
        window.flow.grantingEditUser(parseInt(groupid), parseInt(userid), [
            { 'name': option, 'value': { ...lastCustomData } }
        ], true).then((res) => {
            dispatch(saveLastCustomData4UserSuccess(res));
        }).catch(err => {
            console.log("LAMTEST grantingEditUser err", err);
        });
    }
}

export const saveCustomCurrentUser = (user) => {
    return {
        type: actionTypes.CUSTOM_SAVE_CURRENTUSER,
        payload: user
    }
}

export const setCustomHistory = (action) => {
    return {
        type: actionTypes.CUSTOM_SET_HISTORY,
        payload: action
    }
}


export const setCustomCurrentSortOption = (option) => {
    return {
        type: actionTypes.CUSTOM_SET_CURRENT_SORTOPTION,
        payload: option
    }
}

export const getCustomLastSearch = (data) => {
    return {
        type: actionTypes.CUSTOM_GET_LAST_SEARCH,
        payload: data
    }
}

export const setCustomCurrentDialog = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_CURRENT_DIALOG,
        payload: data
    }
}


export const reloadCustomProject = (data) => {
    return {
        type: actionTypes.CUSTOM_RELOAD_PROJECT,
        payload: data
    }
}

export const setCustomCurrentProject = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_CURRENT_PROJECT,
        payload: data
    }
}

export const setCustomEmptyProjects = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_EMPTY_PROJECTS,
        payload: data
    }
}

export const setCustomDeletedProjects = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_DELETED_PROJECTS,
        payload: data
    }
}

export const setCustomDeletedRooms = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_DELETED_ROOMS,
        payload: data
    }
}

export const setCustomUpdatedProjects = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_UPDATED_PROJECTS,
        payload: data
    }
}

export const getCustomConfigClipInfoForApp = (data) => {
    return {
        type: actionTypes.CUSTOM_GET_CONFIGCLIPINFO_FORAPP,
        payload: data
    }
}

export const getCustomUiConfigForApp = (data) => {
    return {
        type: actionTypes.CUSTOM_GET_UICONFIG_FORAPP,
        payload: data
    }
}

export const setCustomCurrentMainFilter = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_CURRENT_MAIN_FILTER,
        payload: data
    }
}

export const setCustomCurrentSubFilter = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_CURRENT_SUB_FILTER,
        payload: data
    }
}

export const setCustomUploadInfo = (info) => {
    return {
        type: actionTypes.CUSTOM_SET_UPLOAD_INFO,
        payload: info
    }
}

export const setCustomUploadInfoMaster = (info) => {
    return {
        type: actionTypes.CUSTOM_SET_UPLOAD_INFO_MASTER,
        payload: info
    }
}

export const setCustomSearchInfo = (info) => {
    return {
        type: actionTypes.CUSTOM_SET_SEARCH_INFO,
        payload: info
    }
}

export const setCustomCurrentUploadCount = () => {
    return {
        type: actionTypes.CUSTOM_SET_CURRENT_UPLOAD_COUNT
    }
}

export const toggleCustomPopUpHidden = () => {
    return {
        type: actionTypes.CUSTOM_TOGGLE_POPUP_HIDDEN
    }
}

export const setCustomGoogleSignIn = (data) => {
    return {
        type: actionTypes.CUSTOM_GOOGLE_SIGN_IN,
        payload: data
    }
}

export const getCustomAppDataSuccess = (data, apitype) => {
    return {
        type: actionTypes.CUSTOM_GET_APP_DATA_SUCCESS,
        payload: data,
        apitype: apitype
    }
}

export const getCustomAppDataStart = () => {
    return {
        type: actionTypes.CUSTOM_GET_APP_DATA_START,
    }
}


export const createNewEntrySuccess = (data) => {
    return {
        type: actionTypes.CUSTOM_CREATE_NEW_ENTRY_SUCCESS,
        payload: data
    }
}

export const createNewEntryFail = (err) => {
    return {
        type: actionTypes.CUSTOM_CREATE_NEW_ENTRY_FAIL,
        payload: err
    }
}



export const setCustomInitialState = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_INITIAL_STATE,
        payload: data
    }
}

export const catchCustomErrorsForAppStart = (error) => {
    return {
        type: actionTypes.CUSTOM_CATCH_APP_ERRORS,
        payload: error
    }
}

export const setCustomReportsData = (data) => {
    return {
        type: actionTypes.CUSTOM_SET_REPORTS_DATA,
        payload: data
    }
}

export const getCustomFlexAppConfig = (data) => {
    return {
        type: actionTypes.CUSTOM_GET_FLEX_APP_CONFIG,
        payload: data
    }
}

const getQueryType = (apitype) => {
    switch (apitype) {
        case CustomTypes.API_PARENTSERIES:
            return "program";
        case CustomTypes.API_PROGRAMORSERIES:
            return "programorseries";
        default:
            return null;
    }
}

const searchSeason = (apitype, dispatch, data) => {
    if (data) {
        try {
            window.flow.seriesGetSeasonByFields([{ field: apitype, type: '=', value: data }]).then(res => {
                const resObj = res.objects.elements;
                const appData = Object.keys(resObj).map(key => resObj[key].data ? resObj[key].data : resObj[key]);
                //if (appData && appData.length > 0) {
                if (appData) {
                    dispatch(getCustomAppDataSuccess(appData, apitype));
                }
            }).catch((err) => {
                console.log("seriesGetSeasonByFields ERROR", err);
            });

        } catch (err) {
            console.log("window.seriesGetSeasonByFields is not a function");
        }
    }
}

const startTypeaheadQuery = (apitype, dispatch, data) => {
    let queryType = getQueryType(apitype);
    try {
        switch (apitype) {
            case CustomTypes.API_SERIES_PARENT:
                searchSeason(apitype, dispatch, data);
                break;
            default:
                window.flow.typeaheadQuery(queryType, data).then((res) => {
                    if (res && res.length > 0) dispatch(getCustomAppDataSuccess(res, apitype));
                });
        }
    } catch (err) {
        console.log("window.flow.typeaheadQuery is not a function");
    }
}

const getSeriesTree = (apitype, dispatch) => {
    window.flow.seriesGetTree().then((res) => {
        if (res && res.tree) {
            switch (apitype) {
                case CustomTypes.API_PARENTSERIES:
                    let parentseries = res.tree.filter(item => item.type === CustomTypes.MW_SERIES_PROGRAM);
                    dispatch(getCustomAppDataSuccess(parentseries, apitype));
                    break;
                case CustomTypes.API_PROGRAMORSERIES:
                    dispatch(getCustomAppDataSuccess(res.tree, apitype));
                    break;
            }
        }
    });
}

export const getCustomAppData = (data = null, apitype) => {
    return (dispatch) => {
        dispatch(getCustomAppDataStart());
        if (isNLW()) {
            if (data) startTypeaheadQuery(apitype, dispatch, data);
            else getSeriesTree(apitype, dispatch);
        };
    }
}

export const catchCustomErrorsForApp = (error) => {
    return (dispatch) => {
        dispatch(catchCustomErrorsForAppStart(error));
    }
}


export const updateCustomMetadata = (id, metadata) => {
    return dispatch => {
        window.flow.editClip(id, metadata).then((clip) => {
            console.log("LAMTEST UPDATE METADATA CLIP05 RESPONSE", clip);
        }).catch((res) => {
            console.log(res);
        });
    }
};


export const pushToDoc = (id, type, formatMessage) => {
    return (dispatch, getState) => {
        window.flow.newProcess('batch', 'push to doc', { parameters: { batch: 7, contenttype: type, contentlink: id } })
            .then((res) => {
                let params = [{ msg: "pushClipIdMsg", value: `${id}` }, { msg: "toDocSuccessMsg", value: "" }]
                let msg = DataUtil.translateArrayIntlMsgForApp(params, formatMessage);
                DataUtil.showIntlConfirmDialogWithCallback(msg, formatMessage, () => { });
            })
            .catch((err) => {
                let msg = err.result ? JSON.stringify(err.result) : "Something going wrong!";
                DataUtil.showIntlConfirmDialogWithCallback(msg, formatMessage, () => { });
            })
    }
}

export const addUserToGroup = (user, group, formatMessage, cb) => {
    return (dispatch, getState) => {
        if (user && group) {
            window.flow.userAddToGroup(user, group)
                .then(res => {
                    let params = [{ msg: "addUserMsg", value: `${user}` }, { msg: "toGroupSuccessMsg", value: "" }]
                    let msg = DataUtil.translateArrayIntlMsgForApp(params, formatMessage);
                    DataUtil.showIntlConfirmDialogWithCallback(msg, formatMessage, () => { cb() });
                })
                .catch(err => {
                    let msg = err.result ? JSON.stringify(err.result) : "Something going wrong!";
                    DataUtil.showIntlConfirmDialogWithCallback(msg, formatMessage, () => { });
                });
        }
    }
}

export const removeUserToGroup = (user, group, formatMessage, cb) => {
    return (dispatch, getState) => {
        if (user && group) {
            window.flow.userRemoveFromGroup(user, group)
                .then(res => {
                    let params = [{ msg: "removeUserMsg", value: `${user}` }, { msg: "fromGroupSuccessMsg", value: "" }]
                    let msg = DataUtil.translateArrayIntlMsgForApp(params, formatMessage);
                    DataUtil.showIntlConfirmDialogWithCallback(msg, formatMessage, () => { cb() });
                })
                .catch(err => {
                    let msg = err.result ? JSON.stringify(err.result) : "Something going wrong!";
                    DataUtil.showIntlConfirmDialogWithCallback(msg, formatMessage, () => { });
                });
        }
    }
}

export const sendToWorkflow = (workflow, id, type, formatMessage) => {
    return ((dispatch) => {
        if (workflow) {
            window.flow.workflowSend(workflow.id, id, type).then(res => {
                let params = [{ msg: "sendToWorkflowMsg", value: `${workflow.name}` }, { msg: "successfullyMsg", value: "" }]
                let msg = DataUtil.translateArrayIntlMsgForApp(params, formatMessage);
                DataUtil.showIntlConfirmDialogWithCallback(msg, formatMessage,
                    () => { console.log("workflowSend"); });
            }).catch(res => {
                dispatch(actions.applicationError(res.message));
            })
        }
    })
}

export const getFtvmetaUlConstraints = () => {
    return (dispatch) => {
        window.flow.ftvmetaUlConstraints()
            .then(res => {
                console.log("LAMTEST getFtvmetaUIConstraints RES", res);
                dispatch(actions.getFtvmetaUlConstraintsSuccess(res))
            })
            .catch(err => {
                dispatch(actions.applicationError(err.message));
            })
    }
}

